import env from './.env';

export const ENV = {
    production: false,
    isDebugMode: true,
    odoo_path: 'https://extern.hogakaprofi.de:8080',
    odoo_db: 'rws-2018-test',
    changes: env.npm_package_last_changes,
    version: env.npm_package_version + ' DEV'
}


// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts